import React from 'react'

import { PublicMeetingTypeLocation } from '@/types/responses/meeting-types'

interface Props {
  location: PublicMeetingTypeLocation
}

/**
 * An office's name followed by its address, for the office dropdowns on the
 * booking page. The address is left out when the office has none, e.g. an
 * office without an address that can still handle visits to the client's home.
 */
const OfficeOptionLabel: React.FC<Props> = ({ location }) => (
  <>
    {location.name}
    {location.formattedAddress && (
      <span className="text-muted-foreground">
        ({location.formattedAddress})
      </span>
    )}
  </>
)

export default OfficeOptionLabel
